import type { Permission } from '@cobliteam/permissions';

export enum Location {
  EMPTY = '/',
  HOME = '/home',
  MONITORING = '/monitoring',
  PASSAGE_HISTORY = '/passage-history',
  PASSAGE_HISTORY_RESULTS = '/passage-history/results',
  TRACKING_HISTORY = '/tracking-history',
  TRACKING = '/tracking',

  SPEEDING = '/speeding',

  GEOFENCES = '/geofences',
  GEOFENCES_CREATE = '/geofences/create',
  GEOFENCES_EDIT = '/geofences/edit/:id',

  // Productivity
  PRODUCTIVITY = '/productivity',
  PRODUCTIVITY_LEGACY = '/productivity/legacy',
  PRODUCTIVITY_DASHBOARD = '/productivity/dashboard',
  PRODUCTIVITY_DASHBOARD_VEHICLE_GROUP = '/productivity/dashboard/vehicle-group',

  // Routing
  ROUTING = '/routing',
  ROUTING_EDIT = '/routing/edit',
  ROUTING_PLANNING = '/routing/planning',
  ROUTING_ACTIVITY_EDIT = '/routing/activity-edit',
  ROUTING_ACTIVITIES = '/routing/activities',
  ROUTING_ROUTES = '/routing/routes',

  // Economic Driving
  ECONOMIC_DRIVING = '/economic-driving',
  ECONOMIC_DRIVING_DASHBOARD = '/economic-driving/dashboard',
  ECONOMIC_DRIVING_TYPE = '/economic-driving/dashboard/:type',
  ECONOMIC_DRIVING_VEHICLE = '/economic-driving/dashboard/vehicle',
  ECONOMIC_DRIVING_DRIVER = '/economic-driving/dashboard/driver',

  // Safety Ranking
  SAFETY_RANKING_ROOT = '/safety-ranking',
  SAFETY_RANKING_TYPE = '/safety-ranking/ranking/:type',
  SAFETY_RANKING_DRIVER = '/safety-ranking/ranking/driver',
  SAFETY_RANKING_VEHICLE = '/safety-ranking/ranking/vehicle',
  SAFETY_RANKING_PARAMETERS = '/safety-ranking/parameters',

  // Safety Dashboard
  SAFETY_RANKING_DASHBOARD = '/safety/dashboard/ranking',
  SAFETY_RANKING_DASHBOARD_VEHICLE_GROUP = '/safety/dashboard/ranking/vehicle-group',
  SAFETY_RANKING_DASHBOARD_VEHICLE = '/safety/dashboard/ranking/vehicle',
  SAFETY_RANKING_DASHBOARD_DRIVER = '/safety/dashboard/ranking/driver',

  // fleet policy
  FLEET_POLICY = '/fleet-policy',
  FLEET_POLICY_TYPE = '/fleet-policy/trigger-events/:trigger',
  FLEET_POLICY_GEOFENCE = '/fleet-policy/trigger-events/geofence',
  FLEET_POLICY_IDLE_ENGINE = '/fleet-policy/trigger-events/idle-engine',
  FLEET_POLICY_DEVICE_CONNECTION = '/fleet-policy/trigger-events/device-connection',
  FLEET_POLICY_VEHICLE_SPEED_LIMIT = '/fleet-policy/trigger-events/vehicle-speed-limit',
  FLEET_POLICY_ROAD_SPEED_LIMIT = '/fleet-policy/trigger-events/road-speed-limit',
  FLEET_POLICY_DRIVER_IDENTIFICATION = '/fleet-policy/trigger-events/driver-identification',
  FLEET_POLICY_CHECKLIST = '/fleet-policy/trigger-events/checklist',
  FLEET_POLICY_CAMERAS_HEALTH = '/fleet-policy/trigger-events/cameras-health',
  FLEET_POLICY_LP = '/fleet-policy/landing',
  TRIGGERS = '/fleet-policy/triggers',
  TRIGGERS_CREATE = '/fleet-policy/triggers/create',
  TRIGGERS_EDIT = '/fleet-policy/triggers/edit',

  // new reports
  REPORTS = '/reports',
  REPORTS_NEW = '/report',
  REPORTS_HOME = '/report/home',
  REPORTS_TRIP_AND_STOP_TYPE = '/report/trip-and-stop/:type',
  REPORTS_TRIP_AND_STOP_DAILY = '/report/trip-and-stop/:type/daily',
  REPORTS_TRIP_AND_STOP_DETAILS = '/report/trip-and-stop/details',
  REPORTS_FLEET_SAFETY_TYPE = '/report/safety/:type',
  REPORTS_SAFETY_EVENTS = '/report/safety-event',
  REPORTS_VEHICLE_DEVICE_ASSOCIATION = '/report/vehicle-device-association',
  REPORTS_VEHICLE_DEVICE_ASSOCIATION_TYPE = '/report/vehicle-device-association/:type',
  REPORTS_IDENTIFIER_ASSOCIATION = '/report/identifier-association',

  // additional report routes
  REPORTS_OUT_JOURNEY = '/report/out-journey',
  REPORTS_ROUTES_POINTS = '/report/routes-points',
  REPORTS_PRODUCTIVITY = '/report/productivity',
  REPORTS_DISTANCE_DRIVEN = '/report/distance-driven',
  REPORTS_IDLE_ENGINE = '/report/idle-engine',
  REPORTS_GEOFENCE_EVENTS = '/report/geofence-events',
  REPORTS_INCIDENT = '/report/incident',
  REPORTS_DRIVER_VEHICLE_ASSOCIATION = '/report/driver-vehicle-association',
  REPORTS_CUSTOM_DASHBOARDS = '/report/custom-dashboards',
  REPORTS_CUSTOM_DASHBOARD_DETAILS = '/report/custom-dashboards/:id',

  PROOF_OF_CONCLUSION = '/proof-of-conclusion',
  FUEL_CARD = '/fuel-card',
  VEHICLES = '/vehicles',
  DEVICES = '/devices',
  VEHICLES_GROUPS = '/groups',
  VEHICLES_GROUPS_ID = '/groups/:vehicleGroupId',
  DRIVER_MANAGEMENT = '/driver-management',
  DRIVER_MANAGEMENT_NOT_IDENTIFIED = '/driver-management/not-identified',
  DRIVER_MANAGEMENT_IDENTIFIERS = '/driver-management/identifiers',
  DRIVER_FACE_IMAGES = '/driver-management/:driverId/face-images',

  IDENTIFIERS = '/identifiers',

  MAINTENANCE = '/maintenance',
  MAINTENANCE_DASHBOARD = '/maintenance/dashboard',
  MAINTENANCE_REMINDERS = '/maintenance/reminders',
  MAINTENANCE_HISTORY = '/maintenance/history',

  // Camera
  CAMERA_LP = '/camera',

  MULTICAM_LANDING_PAGE = '/multicam',
  LIVESTREAM = '/livestream',

  CAMERA = '/camera/:type',

  CAMERA_EVENTS = '/camera/events',
  CAMERA_EVENTS_DETAILS = '/camera/events/:mediaId',
  CAMERA_EVENTS_DASHBOARD = '/camera/events/dashboard',
  CAMERA_EVENTS_FAVORITES = '/camera/events/favorites',

  CAMERA_REQUESTS = '/camera/requests',
  CAMERA_REQUESTS_FAVORITES = '/camera/requests/favorites',
  CAMERA_REQUESTS_AUTOMATIC = '/camera/requests/automatic',
  CAMERA_REQUESTS_DETAILS = '/camera/requests/:mediaId',

  CAMERA_TRIP_IMAGE_HISTORY = '/camera/images',
  CAMERA_TRIP_IMAGE_HISTORY_ALL = '/camera/images/:view',
  CAMERA_IMAGES_MATCH_REVIEW = '/match-review',

  // Camera redirects
  CAMERA_REQUEST_REDIRECT = '/camera-request',
  CAMERA_REQUEST_ALL_REDIRECT = '/camera-request/all-requests',
  CAMERA_REQUESTS_FAVORITE_REDIRECT = '/camera-request/favorite',
  CAMERA_EVENT_REDIRECT = '/camera-event',
  CAMERA_EVENT_ALL_REDIRECT = '/camera-event/all-events',
  CAMERA_EVENT_FAVORITE_REDIRECT = '/camera-event/favorite',
  CAMERA_TRIP_IMAGE_PENDING_REDIRECT = '/trip-image-history/pending-nominate',
  CAMERA_TRIP_IMAGE_ALL_REDIRECT = '/trip-image-history/all-trips',
  CAMERA_HEALTH_OBSTRUCTION = '/camera/health',

  // Coaching feedback
  COACHING = '/coaching',
  COACHING_ROOT = '/coaching/:path',
  COACHING_ONGOING = '/coaching/ongoing',
  COACHING_FINISHED = '/coaching/finished',
  COACHING_DETAILS = '/coaching/:coachingId',

  CHECKLIST = '/checklist',
  CHECKLIST_DASHBOARD = '/checklist/dashboard',
  CHECKLIST_RESPONSE = '/checklist/response/:checklistId',
  CHECKLIST_ALL = '/checklist/all',

  PRISMIC_PREVIEW = '/preview',
  APPS = '/apps',
  APIS = '/apis',
  WEBHOOKS = '/webhooks',
  CONFIG = '/config',
  CONFIG_ACCOUNT = '/config/account',
  CONFIG_NOTIFICATIONS_CENTER = '/config/notifications-center',
  CONFIG_USERS = '/config/users',
  CONFIG_ALERTS = '/config/alerts',
  CONFIG_EVENTS_CONFIGURATION = '/config/events-configuration',
  CONFIG_CAMERA_WIFI_CONFIGURATION = '/config/camera-wifi-configuration',
  CONFIG_FACE_ID = '/config/face-id',
  PASSWORD_RECOVERY = '/password-recovery',
  TOKEN_VALIDATION = '/already-have-token',
  PASSWORD_RESET = '/password-reset',
  LOGIN = '/login',
  LOGOUT = '/logout',
  MFA_CHALLENGE = '/mfa-challenge',
  NOT_FOUND = '/not-found',
  NO_FLEET_ACCESS = '/no-fleet-access',
  ORDERS = '/orders',
  BUSINESS_MANAGER = '/business-manager',
  BUSINESS_MANAGER_TICKETS = '/business-manager/ticket',
  BUSINESS_MANAGER_DETAIL = '/business-manager/ticket-detail',
  BUSINESS_MANAGER_BOLETOS = '/business-manager/boletos',
  BUSINESS_MANAGER_CONTRATO = '/business-manager/contracts',
  TRAINING = '/training',

  // Orders
  ORDER_DETAILS = '/orders/details/:orderId',

  // Road Speed
  ROAD_SPEED = '/road-speed',

  // Expenses
  EXPENSES_PAGE = '/expenses',
  EXPENSES_HISTORY = '/expenses/history',
  EXPENSES_VEHICLE = '/expenses/vehicle',

  // Fines
  FINES = '/fines',

  // Path Association
  PATH_ASSOCIATION = '/path-association',
  PATH_ASSOCIATION_VEHICLE = '/path-association/vehicle/:vehicleId',

  // news
  NEWS = '/news',

  // AI
  AI = '/ai',
  AI_INSIGHTS = '/ai/insights',
  AI_AUTOMATION = '/ai/automations',
  AI_FILES = '/ai/files',
  AI_AUTOMATION_RUNS = '/ai/automations/:automationId',
}

// Every location must have a mapped name for page view
export const locationName: Record<Location, string> = {
  [Location.PRISMIC_PREVIEW]: 'Prismic Preview',
  [Location.EMPTY]: '',
  [Location.HOME]: 'Início',
  [Location.MONITORING]: 'Monitoramento',
  [Location.PASSAGE_HISTORY]: 'Histórico de passagem',
  [Location.PASSAGE_HISTORY_RESULTS]: 'Resultados do histórico de passagem',
  [Location.TRACKING_HISTORY]: 'Trajetos',
  [Location.TRACKING]: 'Trajeto',
  [Location.ROUTING]: 'Torre de controle',
  [Location.ROUTING_ACTIVITIES]: 'Atividades',
  [Location.ROUTING_ROUTES]: 'Rotas',
  [Location.ROUTING_PLANNING]: 'Adicionar',
  [Location.ROUTING_EDIT]: 'Edição de rota',
  [Location.ROUTING_ACTIVITY_EDIT]: 'Edição de atividade',
  [Location.ECONOMIC_DRIVING]: 'Condução econômica',
  [Location.ECONOMIC_DRIVING_DASHBOARD]: 'Condução econômica',
  [Location.ECONOMIC_DRIVING_TYPE]: 'Condução econômica',
  [Location.ECONOMIC_DRIVING_VEHICLE]: 'Condução econômica',
  [Location.ECONOMIC_DRIVING_DRIVER]: 'Condução econômica',
  [Location.GEOFENCES]: 'Locais de interesse',
  [Location.GEOFENCES_CREATE]: 'Criar Local de Interesse',
  [Location.GEOFENCES_EDIT]: 'Editar Local de Interesse',
  [Location.PRODUCTIVITY]: 'Produtividade',
  [Location.PRODUCTIVITY_LEGACY]: 'Produtividade',
  [Location.PRODUCTIVITY_DASHBOARD]: 'Produtividade',
  [Location.PRODUCTIVITY_DASHBOARD_VEHICLE_GROUP]: 'Produtividade',
  [Location.SPEEDING]: 'Velocidade',
  [Location.LIVESTREAM]: 'Câmeras ao vivo',
  [Location.REPORTS]: 'Relatórios',
  [Location.REPORTS_NEW]: 'Relatórios',
  [Location.REPORTS_HOME]: 'Relatórios',
  [Location.REPORTS_TRIP_AND_STOP_TYPE]: 'Relatório de trajetos e paradas',
  [Location.REPORTS_TRIP_AND_STOP_DETAILS]: 'Relatório de trajetos e paradas detalhado',
  [Location.REPORTS_TRIP_AND_STOP_DAILY]: 'Relatório de trajetos e paradas diário',
  [Location.REPORTS_FLEET_SAFETY_TYPE]: 'Relatório de eventos de segurança',
  [Location.REPORTS_SAFETY_EVENTS]: 'Relatório de eventos de segurança detalhado',
  [Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION]: 'Relatório de histórico de associações de veículos e dispositivos',
  [Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION_TYPE]: 'Relatório de histórico de associações de veículos e dispositivos',
  [Location.REPORTS_IDENTIFIER_ASSOCIATION]: 'Relatório de histórico de associações de chaveiros',
  [Location.REPORTS_OUT_JOURNEY]: 'Relatório de saída de viagem',
  [Location.REPORTS_ROUTES_POINTS]: 'Relatório de pontos de rota',
  [Location.REPORTS_PRODUCTIVITY]: 'Relatório de produtividade',
  [Location.REPORTS_DISTANCE_DRIVEN]: 'Relatório de distância percorrida',
  [Location.REPORTS_IDLE_ENGINE]: 'Relatório de motor ocioso',
  [Location.REPORTS_GEOFENCE_EVENTS]: 'Relatório de eventos de geofence',
  [Location.REPORTS_INCIDENT]: 'Relatório de incidente',
  [Location.REPORTS_DRIVER_VEHICLE_ASSOCIATION]: 'Relatório de associação de motorista e veículo',
  [Location.PROOF_OF_CONCLUSION]: 'Comprovantes',
  [Location.FUEL_CARD]: 'Gestão de combustível',
  [Location.MAINTENANCE]: 'Manutenção',
  [Location.MAINTENANCE_DASHBOARD]: 'Análises',
  [Location.MAINTENANCE_REMINDERS]: 'Lembretes de manutenções',
  [Location.MAINTENANCE_HISTORY]: 'Histórico de manutenções',
  [Location.VEHICLES]: 'Veículos',
  [Location.VEHICLES_GROUPS]: 'Grupos de veículos',
  [Location.VEHICLES_GROUPS_ID]: 'Grupo de Veículos',
  [Location.DEVICES]: 'Dispositivos',
  [Location.DRIVER_MANAGEMENT]: 'Motoristas',
  [Location.DRIVER_MANAGEMENT_NOT_IDENTIFIED]: 'Motoristas não identificados',
  [Location.DRIVER_MANAGEMENT_IDENTIFIERS]: 'Identificadores não vinculados',
  [Location.DRIVER_FACE_IMAGES]: 'Fotos do motorista',
  [Location.IDENTIFIERS]: 'Identificadores',
  [Location.CHECKLIST]: 'Checklists',
  [Location.CHECKLIST_DASHBOARD]: 'Checklists',
  [Location.CHECKLIST_RESPONSE]: 'Respostas de Checklists',
  [Location.CHECKLIST_ALL]: 'Todos os checklists',
  [Location.APPS]: 'Aplicativos',
  [Location.APIS]: 'APIs',
  [Location.WEBHOOKS]: 'Webhooks',
  [Location.FINES]: 'Multas',
  [Location.FLEET_POLICY]: 'Política de frota',
  [Location.FLEET_POLICY_TYPE]: 'Política de frota',
  [Location.FLEET_POLICY_GEOFENCE]: 'Política de frota - Locais de interesse',
  [Location.FLEET_POLICY_IDLE_ENGINE]: 'Política de frota - Motor ocioso',
  [Location.FLEET_POLICY_DEVICE_CONNECTION]: 'Política de frota - Situação do dispositivo',
  [Location.FLEET_POLICY_VEHICLE_SPEED_LIMIT]: 'Política de frota - Velocidade do veículo',
  [Location.FLEET_POLICY_ROAD_SPEED_LIMIT]: 'Política de frota - Velocidade da via',
  [Location.FLEET_POLICY_DRIVER_IDENTIFICATION]: 'Política de frota - Identificação de motorista',
  [Location.FLEET_POLICY_CHECKLIST]: 'Política de frota - Checklist',
  [Location.FLEET_POLICY_CAMERAS_HEALTH]: 'Política de frota - saúde das câmeras',
  [Location.FLEET_POLICY_LP]: 'Política de frota',
  [Location.TRIGGERS]: 'Política de frota',
  [Location.TRIGGERS_CREATE]: 'Política de frota',
  [Location.TRIGGERS_EDIT]: 'Política de frota',
  [Location.CONFIG]: 'Configurações gerais',
  [Location.CONFIG_ACCOUNT]: 'Sua conta',
  [Location.CONFIG_NOTIFICATIONS_CENTER]: 'Central de notificações',
  [Location.CONFIG_USERS]: 'Usuários',
  [Location.CONFIG_ALERTS]: 'Alertas',
  [Location.CONFIG_EVENTS_CONFIGURATION]: 'Configuração de eventos',
  [Location.CONFIG_CAMERA_WIFI_CONFIGURATION]: 'Configuração de câmeras Wi-Fi',
  [Location.CONFIG_FACE_ID]: 'Configuração de identificação facial',
  [Location.PASSWORD_RECOVERY]: 'Esqueceu a senha',
  [Location.TOKEN_VALIDATION]: 'Validação de código de segurança',
  [Location.PASSWORD_RESET]: 'Definir nova senha',
  [Location.LOGIN]: 'Login',
  [Location.LOGOUT]: 'Sair do sistema',
  [Location.MFA_CHALLENGE]: 'Código de segurança',
  [Location.CAMERA_LP]: 'Cam',
  [Location.CAMERA]: 'Cam',
  [Location.CAMERA_EVENTS]: 'Eventos de vídeo',
  [Location.CAMERA_EVENTS_DETAILS]: 'Detalhes do vídeo',
  [Location.CAMERA_EVENTS_DASHBOARD]: 'Eventos de vídeo',
  [Location.CAMERA_EVENTS_FAVORITES]: 'Eventos de vídeo',
  [Location.CAMERA_TRIP_IMAGE_HISTORY]: 'Identificação facial',
  [Location.CAMERA_TRIP_IMAGE_HISTORY_ALL]: 'Identificação facial',
  [Location.CAMERA_REQUEST_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_REQUEST_ALL_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_REQUESTS_FAVORITE_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_EVENT_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_EVENT_ALL_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_EVENT_FAVORITE_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_TRIP_IMAGE_PENDING_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_TRIP_IMAGE_ALL_REDIRECT]: 'Cobli Cam',
  [Location.CAMERA_HEALTH_OBSTRUCTION]: 'Saúde das câmeras',
  [Location.CAMERA_IMAGES_MATCH_REVIEW]: 'Revisão de imagens',
  [Location.MULTICAM_LANDING_PAGE]: 'Cobli Cam Multi',
  [Location.CAMERA_REQUESTS]: 'Vídeos solicitados',
  [Location.CAMERA_REQUESTS_FAVORITES]: 'Vídeos solicitados',
  [Location.CAMERA_REQUESTS_AUTOMATIC]: 'Vídeos solicitados',
  [Location.CAMERA_REQUESTS_DETAILS]: 'Detalhes do vídeo',
  [Location.COACHING]: 'Tratativas de ocorrências',
  [Location.COACHING_ROOT]: 'Tratativas de ocorrências',
  [Location.COACHING_ONGOING]: 'Tratativas de ocorrências',
  [Location.COACHING_FINISHED]: 'Tratativas de ocorrências',
  [Location.COACHING_DETAILS]: 'Detalhes da tratativa',
  [Location.NOT_FOUND]: 'Página não encontrada',
  [Location.NO_FLEET_ACCESS]: 'Frota sem acesso',
  [Location.ORDERS]: 'Pedidos',
  [Location.BUSINESS_MANAGER]: 'Área do cliente',
  [Location.BUSINESS_MANAGER_TICKETS]: 'Área do cliente',
  [Location.BUSINESS_MANAGER_DETAIL]: 'Área do cliente',
  [Location.BUSINESS_MANAGER_BOLETOS]: 'Área do cliente',
  [Location.BUSINESS_MANAGER_CONTRATO]: 'Área do cliente',
  [Location.SAFETY_RANKING_ROOT]: 'Ranking de condução',
  [Location.SAFETY_RANKING_TYPE]: 'Ranking de condução',
  [Location.SAFETY_RANKING_DRIVER]: 'Ranking de condução de motoristas',
  [Location.SAFETY_RANKING_VEHICLE]: 'Ranking de condução de veículos',
  [Location.SAFETY_RANKING_PARAMETERS]: 'Ranking de condução',
  [Location.SAFETY_RANKING_DASHBOARD]: 'Visão geral',
  [Location.SAFETY_RANKING_DASHBOARD_VEHICLE_GROUP]: 'Visão geral',
  [Location.SAFETY_RANKING_DASHBOARD_VEHICLE]: 'Visão geral',
  [Location.SAFETY_RANKING_DASHBOARD_DRIVER]: 'Visão geral',
  [Location.TRAINING]: 'Treinamentos',
  [Location.ROAD_SPEED]: 'Velocidades da via',
  [Location.EXPENSES_PAGE]: 'Despesas operacionais',
  [Location.EXPENSES_HISTORY]: 'Despesas operacionais',
  [Location.EXPENSES_VEHICLE]: 'Despesas operacionais por Veículos',
  [Location.PATH_ASSOCIATION]: 'Associação de trechos',
  [Location.PATH_ASSOCIATION_VEHICLE]: 'Associação de trechos',
  [Location.NEWS]: 'Novidades',
  [Location.AI]: 'IA',
  [Location.AI_INSIGHTS]: 'IA - Insights',
  [Location.AI_AUTOMATION]: 'IA - Automações',
  [Location.AI_FILES]: 'IA - Arquivos',
  [Location.AI_AUTOMATION_RUNS]: 'IA - Execuções da Automação',
  [Location.REPORTS_CUSTOM_DASHBOARDS]: 'Dashboards Personalizados',
  [Location.REPORTS_CUSTOM_DASHBOARD_DETAILS]: 'Detalhes do Dashboard Personalizado',
  [Location.ORDER_DETAILS]: 'Detalhes do pedido',
};

// Every location must have a minimum user permission mapped. Or none if no special permission is required
export const locationUserPermission: Record<Location, Permission> = {
  // administrate:api-integrations
  [Location.APIS]: 'administrate:api-integrations',
  [Location.APPS]: 'administrate:api-integrations',
  [Location.WEBHOOKS]: 'administrate:api-integrations',

  [Location.GEOFENCES]: 'view:places-of-interest',
  [Location.GEOFENCES_CREATE]: 'view:places-of-interest',
  [Location.GEOFENCES_EDIT]: 'view:places-of-interest',
  [Location.PASSAGE_HISTORY]: 'view:places-of-interest',
  [Location.PASSAGE_HISTORY_RESULTS]: 'view:places-of-interest',

  // basic:permission
  [Location.BUSINESS_MANAGER]: 'basic:permission',
  [Location.BUSINESS_MANAGER_DETAIL]: 'basic:permission',
  [Location.BUSINESS_MANAGER_TICKETS]: 'basic:permission',
  [Location.CAMERA_LP]: 'basic:permission',
  [Location.CONFIG]: 'basic:permission',
  [Location.CONFIG_ACCOUNT]: 'basic:permission',
  [Location.CONFIG_ALERTS]: 'basic:permission',
  [Location.CONFIG_CAMERA_WIFI_CONFIGURATION]: 'basic:permission',
  [Location.CONFIG_EVENTS_CONFIGURATION]: 'basic:permission',
  [Location.CONFIG_NOTIFICATIONS_CENTER]: 'basic:permission',
  [Location.CONFIG_USERS]: 'basic:permission',
  [Location.ORDERS]: 'create-update-delete:crm',
  [Location.CONFIG_FACE_ID]: 'basic:permission',
  [Location.DEVICES]: 'basic:permission',
  [Location.DRIVER_MANAGEMENT]: 'basic:permission',
  [Location.DRIVER_MANAGEMENT_NOT_IDENTIFIED]: 'basic:permission',
  [Location.DRIVER_MANAGEMENT_IDENTIFIERS]: 'basic:permission',
  [Location.DRIVER_FACE_IMAGES]: 'update:driver-face-cluster',
  [Location.IDENTIFIERS]: 'create-update-delete:driver',
  [Location.EMPTY]: 'basic:permission',
  [Location.HOME]: 'basic:permission',
  [Location.LOGIN]: 'basic:permission',
  [Location.LOGOUT]: 'basic:permission',
  [Location.MONITORING]: 'basic:permission',
  [Location.MULTICAM_LANDING_PAGE]: 'basic:permission',
  [Location.NO_FLEET_ACCESS]: 'basic:permission',
  [Location.NOT_FOUND]: 'basic:permission',
  [Location.PASSWORD_RECOVERY]: 'basic:permission',
  [Location.PASSWORD_RESET]: 'basic:permission',
  [Location.MFA_CHALLENGE]: 'basic:permission',
  [Location.PRISMIC_PREVIEW]: 'basic:permission',
  [Location.ROAD_SPEED]: 'basic:permission',
  [Location.TOKEN_VALIDATION]: 'basic:permission',
  [Location.TRAINING]: 'basic:permission',
  [Location.TRACKING]: 'basic:permission',
  [Location.TRACKING_HISTORY]: 'basic:permission',
  [Location.VEHICLES]: 'basic:permission',
  [Location.VEHICLES_GROUPS]: 'basic:permission',
  [Location.VEHICLES_GROUPS_ID]: 'basic:permission',
  [Location.NEWS]: 'basic:permission',
  // config-and-view:custom-alerts
  [Location.FLEET_POLICY]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_CAMERAS_HEALTH]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_CHECKLIST]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_DEVICE_CONNECTION]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_DRIVER_IDENTIFICATION]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_GEOFENCE]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_IDLE_ENGINE]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_LP]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_ROAD_SPEED_LIMIT]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_TYPE]: 'config-and-view:custom-alerts',
  [Location.FLEET_POLICY_VEHICLE_SPEED_LIMIT]: 'config-and-view:custom-alerts',
  [Location.TRIGGERS]: 'config-and-view:custom-alerts',
  [Location.TRIGGERS_CREATE]: 'config-and-view:custom-alerts',
  [Location.TRIGGERS_EDIT]: 'config-and-view:custom-alerts',

  // create-update-delete:routes
  [Location.ROUTING_EDIT]: 'create-update-delete:routes',
  [Location.ROUTING_PLANNING]: 'create-update-delete:routes',
  [Location.ROUTING_ACTIVITY_EDIT]: 'create-update-delete:routes',

  // full-control:checklist
  [Location.CHECKLIST]: 'full-control:checklist',
  [Location.CHECKLIST_DASHBOARD]: 'full-control:checklist',
  [Location.CHECKLIST_RESPONSE]: 'full-control:checklist',
  [Location.CHECKLIST_ALL]: 'full-control:checklist',

  // full-control:maintenance
  [Location.MAINTENANCE]: 'full-control:maintenance',
  [Location.MAINTENANCE_DASHBOARD]: 'full-control:maintenance',
  [Location.MAINTENANCE_HISTORY]: 'full-control:maintenance',
  [Location.MAINTENANCE_REMINDERS]: 'full-control:maintenance',

  // read:hubspot-contracts
  [Location.BUSINESS_MANAGER_CONTRATO]: 'read:hubspot-contracts',

  // update:driver-face-cluster
  [Location.CAMERA_TRIP_IMAGE_ALL_REDIRECT]: 'update:driver-face-cluster',
  [Location.CAMERA_TRIP_IMAGE_HISTORY]: 'update:driver-face-cluster',
  [Location.CAMERA_TRIP_IMAGE_HISTORY_ALL]: 'update:driver-face-cluster',
  [Location.CAMERA_IMAGES_MATCH_REVIEW]: 'update:driver-face-cluster',
  [Location.CAMERA_TRIP_IMAGE_PENDING_REDIRECT]: 'update:driver-face-cluster',

  // view:analytics-and-reports
  [Location.ECONOMIC_DRIVING]: 'view:analytics-and-reports',
  [Location.ECONOMIC_DRIVING_DASHBOARD]: 'view:analytics-and-reports',
  [Location.ECONOMIC_DRIVING_DRIVER]: 'view:analytics-and-reports',
  [Location.ECONOMIC_DRIVING_TYPE]: 'view:analytics-and-reports',
  [Location.ECONOMIC_DRIVING_VEHICLE]: 'view:analytics-and-reports',
  [Location.PRODUCTIVITY]: 'view:analytics-and-reports',
  [Location.PRODUCTIVITY_DASHBOARD]: 'view:analytics-and-reports',
  [Location.PRODUCTIVITY_DASHBOARD_VEHICLE_GROUP]: 'view:analytics-and-reports',
  [Location.PRODUCTIVITY_LEGACY]: 'view:analytics-and-reports',
  [Location.REPORTS]: 'view:analytics-and-reports',
  [Location.REPORTS_DISTANCE_DRIVEN]: 'view:analytics-and-reports',
  [Location.REPORTS_DRIVER_VEHICLE_ASSOCIATION]: 'view:analytics-and-reports',
  [Location.REPORTS_FLEET_SAFETY_TYPE]: 'view:analytics-and-reports',
  [Location.REPORTS_GEOFENCE_EVENTS]: 'view:analytics-and-reports',
  [Location.REPORTS_HOME]: 'view:analytics-and-reports',
  [Location.REPORTS_IDENTIFIER_ASSOCIATION]: 'view:analytics-and-reports',
  [Location.REPORTS_IDLE_ENGINE]: 'view:analytics-and-reports',
  [Location.REPORTS_INCIDENT]: 'view:analytics-and-reports',
  [Location.REPORTS_NEW]: 'view:analytics-and-reports',
  [Location.REPORTS_OUT_JOURNEY]: 'view:analytics-and-reports',
  [Location.REPORTS_PRODUCTIVITY]: 'view:analytics-and-reports',
  [Location.REPORTS_ROUTES_POINTS]: 'view:analytics-and-reports',
  [Location.REPORTS_SAFETY_EVENTS]: 'view:analytics-and-reports',
  [Location.REPORTS_TRIP_AND_STOP_DAILY]: 'view:analytics-and-reports',
  [Location.REPORTS_TRIP_AND_STOP_DETAILS]: 'view:analytics-and-reports',
  [Location.REPORTS_TRIP_AND_STOP_TYPE]: 'view:analytics-and-reports',
  [Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION]: 'view:analytics-and-reports',
  [Location.REPORTS_VEHICLE_DEVICE_ASSOCIATION_TYPE]: 'view:analytics-and-reports',
  [Location.REPORTS_CUSTOM_DASHBOARDS]: 'view:analytics-and-reports',
  [Location.REPORTS_CUSTOM_DASHBOARD_DETAILS]: 'view:analytics-and-reports',

  // view:camera-media
  [Location.CAMERA]: 'view:camera-media',
  [Location.CAMERA_EVENT_ALL_REDIRECT]: 'view:camera-media',
  [Location.CAMERA_EVENT_FAVORITE_REDIRECT]: 'view:camera-media',
  [Location.CAMERA_EVENT_REDIRECT]: 'view:camera-media',
  [Location.CAMERA_EVENTS]: 'view:camera-media',
  [Location.CAMERA_EVENTS_DASHBOARD]: 'view:camera-media',
  [Location.CAMERA_EVENTS_DETAILS]: 'view:camera-media',
  [Location.CAMERA_EVENTS_FAVORITES]: 'view:camera-media',
  [Location.CAMERA_HEALTH_OBSTRUCTION]: 'view:camera-media',
  [Location.CAMERA_REQUESTS]: 'view:camera-media',
  [Location.CAMERA_REQUESTS_AUTOMATIC]: 'view:camera-media',
  [Location.CAMERA_REQUESTS_DETAILS]: 'view:camera-media',
  [Location.CAMERA_REQUESTS_FAVORITES]: 'view:camera-media',
  [Location.CAMERA_REQUESTS_FAVORITE_REDIRECT]: 'view:camera-media',
  [Location.CAMERA_REQUEST_ALL_REDIRECT]: 'view:camera-media',
  [Location.CAMERA_REQUEST_REDIRECT]: 'view:camera-media',
  [Location.LIVESTREAM]: 'view:camera-media',

  // request:camera-media
  [Location.COACHING]: 'request:camera-media',
  [Location.COACHING_ROOT]: 'request:camera-media',
  [Location.COACHING_ONGOING]: 'request:camera-media',
  [Location.COACHING_FINISHED]: 'request:camera-media',
  [Location.COACHING_DETAILS]: 'request:camera-media',

  // view:fleet-expenses
  [Location.EXPENSES_HISTORY]: 'view:fleet-expenses',
  [Location.EXPENSES_PAGE]: 'view:fleet-expenses',
  [Location.EXPENSES_VEHICLE]: 'view:fleet-expenses',
  [Location.FINES]: 'view:fleet-expenses',

  // view:fleet-safety
  [Location.SAFETY_RANKING_ROOT]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_DASHBOARD]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_DASHBOARD_DRIVER]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_DASHBOARD_VEHICLE]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_DASHBOARD_VEHICLE_GROUP]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_DRIVER]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_TYPE]: 'view:fleet-safety',
  [Location.SAFETY_RANKING_VEHICLE]: 'view:fleet-safety',
  [Location.SPEEDING]: 'view:fleet-safety',

  // view:fuel-card
  [Location.FUEL_CARD]: 'view:fuel-card',

  // view:proof-of-conclusion
  [Location.PROOF_OF_CONCLUSION]: 'view:proof-of-conclusion',

  // view:routes
  [Location.ROUTING]: 'view:routes',
  [Location.ROUTING_ACTIVITIES]: 'view:routes',
  [Location.ROUTING_ROUTES]: 'view:routes',

  // write:fleet-safety
  [Location.SAFETY_RANKING_PARAMETERS]: 'write:fleet-safety',

  // write:hubspot-finance
  [Location.BUSINESS_MANAGER_BOLETOS]: 'write:hubspot-finance',

  // write:orders
  [Location.ORDER_DETAILS]: 'create-update-delete:crm',

  // basic:permission
  [Location.PATH_ASSOCIATION]: 'basic:permission',
  [Location.PATH_ASSOCIATION_VEHICLE]: 'basic:permission',

  // basic:permission
  [Location.AI]: 'basic:permission',
  [Location.AI_INSIGHTS]: 'basic:permission',
  [Location.AI_AUTOMATION]: 'basic:permission',
  [Location.AI_FILES]: 'basic:permission',
  [Location.AI_AUTOMATION_RUNS]: 'basic:permission',
};
